/**
 * @generated SignedSource<<e72c8a6eb37a184b737662e991f34435>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type abTestHelper_viewer$data = {
  readonly sponsoredListing: boolean | null;
  readonly " $fragmentType": "abTestHelper_viewer";
};
export type abTestHelper_viewer$key = {
  readonly " $data"?: abTestHelper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"abTestHelper_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "abTestHelper_viewer"
};

(node as any).hash = "32891bb842b042f2ec21e5ff161bdbe3";

export default node;
